import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { BrowserModule } from "@angular/platform-browser";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { AccordionModule } from "primeng/accordion";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ColorPickerModule } from "primeng/colorpicker";

import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { BusTrackerComponent } from "./components/bustracker.component";
import { BusTrackerActivationComponent } from "./bus-tracker-activation/bus-tracker-activation.component";
import { AddBTActivationComponent } from "./bus-tracker-activation/add-btactivation/add-btactivation.component";
import { EditBTActivationComponent } from "./bus-tracker-activation/edit-btactivation/edit-btactivation.component";
import { EmailBTActivationComponent } from "./bus-tracker-activation/email-btactivation/email-btactivation.component";
import { DataService_BusTrackerActivation } from "./bus-tracker-activation/shared/data.service";
import { GMapModule } from "./bus-tracker-main-map/shared/gmap";
import { DataService_BusTrackerMap } from "./bus-tracker-main-map/shared/data.service";
import { BusSelectorComponent } from "./bus-tracker-main-map/bus-selector/bus-selector.component";
import { BusSelectorBusResultsComponent } from "./bus-tracker-main-map/bus-selector/bus-selector-bus-results/bus-selector-bus-results.component";
import { BusSelectorStudentResultsComponent } from "./bus-tracker-main-map/bus-selector/bus-selector-student-results/bus-selector-student-results.component";
import { SchoolBusAlertModifyComponent } from "./bus-tracker-main-map/bus-main-map/school-bus-alert-modify/school-bus-alert-modify.component";
import { SchoolBusAlertBusTableComponent } from "./bus-tracker-main-map/bus-main-map/school-bus-alert-modify/school-bus-alert-bus-table/school-bus-alert-bus-table.component";
import { SchoolBusAlertTableComponent } from "./bus-tracker-main-map/school-bus-alert-table/school-bus-alert-table.component";
import { BusMaintenanceComponent } from "./bus-maintenance/bus-maintenance.component";
import { BusMaintenanceBusTableComponent } from "./bus-maintenance/bus-maintenance-bus-table/bus-maintenance-bus-table.component";
import { BusMaintenanceRouteTableComponent } from "./bus-maintenance/bus-maintenance-route-table/bus-maintenance-route-table.component";
import { BusMaintenanceStudentTableComponent } from "./bus-maintenance/bus-maintenance-student-table/bus-maintenance-student-table.component";
import { BusAlertTypeMaintenanceComponent } from "./bus-alert-type-maintenance/bus-alert-type-maintenance.component";
import { BusRouteTypeMaintenanceComponent } from "./bus-route-type-maintenance/bus-route-type-maintenance.component";
import { DataService_BusTrackerAlertType } from "./bus-alert-type-maintenance/shared/data.service";
import { BusAlertTypeModifyComponent } from "./bus-alert-type-maintenance/bus-alert-type-modify/bus-alert-type-modify.component";
import { DataService_BusTrackerRouteType } from "./bus-route-type-maintenance/shared/data.service";
import { BusRouteTypeModifyComponent } from "./bus-route-type-maintenance/bus-route-type-modify/bus-route-type-modify.component";
import { DataService_BusTrackerBusMaintenance } from "./bus-maintenance/shared/data.service";
import { BusModifyComponent } from "./bus-maintenance/bus-maintenance-bus-table/bus-modify/bus-modify.component";
import { RouteModifyComponent } from "./bus-maintenance/bus-maintenance-route-table/route-modify/route-modify.component";
import { AssignStudentsComponent } from "./bus-maintenance/bus-maintenance-student-table/assign-students/assign-students.component";
import { BusTrackerScanHistoryComponent } from "./bus-tracker-scan-history/bus-tracker-scan-history.component";
import { BusAlertTableComponent } from "./bus-tracker-main-map/bus-alert-table/bus-alert-table.component";
import { BusTrackerGeoFenceMaintenanceComponent } from "./bus-tracker-geo-fence-maintenance/bus-tracker-geo-fence-maintenance.component";
import { DataService_BusTrackerGeoFenceMaintenance } from "./bus-tracker-geo-fence-maintenance/shared/data.service";
import { GeoFenceSideBarComponent } from "./bus-tracker-geo-fence-maintenance/geo-fence-side-bar/geo-fence-side-bar.component";
import { AddGeoFenceComponent } from "./bus-tracker-geo-fence-maintenance/add-geo-fence/add-geo-fence.component";
import { EditGeoFenceComponent } from "./bus-tracker-geo-fence-maintenance/edit-geo-fence/edit-geo-fence.component";
import { GeoFenceAlertTableComponent } from "./bus-tracker-main-map/geo-fence-alert-table/geo-fence-alert-table.component";
import { DataService_BusTrackerScanHistory } from "./bus-tracker-scan-history/shared/data.service";
import { BusTrackerImportComponent } from "./bus-maintenance/bus-tracker-import/bus-tracker-import.component";
import { BusHistorySelectorComponent } from "./bus-tracker-bus-history/bus-history-selector/bus-history-selector.component";
import { BusHistorySelectorBusResultsComponent } from "./bus-tracker-bus-history/bus-history-selector/bus-history-selector-bus-results/bus-history-selector-bus-results.component";
import { BusTrackerBusHistoryComponent } from "./bus-tracker-bus-history/bus-tracker-bus-history.component";
import { DataService_BusTrackerBusHistory } from "./bus-tracker-bus-history/shared/data.service";
import { BusHistorySelectorStudentResultsComponent } from "./bus-tracker-bus-history/bus-history-selector/bus-history-selector-student-results/bus-history-selector-student-results.component";
import { BusTrackerMainMapComponent } from "./bus-tracker-main-map/bus-tracker-main-map.component";
import { BusMainMapComponent } from "./bus-tracker-main-map/bus-main-map/bus-main-map.component";
import { BusTrackerSettingsComponent } from "./bus-tracker-settings/bus-tracker-settings.component";
import { DataService_BusTrackerSettings } from "./bus-tracker-settings/shared/data.service";
import { BusOverviewTableComponent } from "./bus-overview-table/bus-overview-table.component";
import { DataService_BusTrackerBusOverview } from "./bus-overview-table/shared/data.service";
import { BusOverviewStudentTableComponent } from "./bus-overview-table/bus-overview-student-table/bus-overview-student-table.component";
import { BusTrackerGeoFenceHistoryComponent } from "./bus-tracker-geo-fence-history/bus-tracker-geo-fence-history.component";
import { DataService_BusTrackerGeoFenceHistory } from "./bus-tracker-geo-fence-history/shared/data.service";
import { GeoFenceHistorySelectorComponent } from "./bus-tracker-geo-fence-history/geo-fence-history-selector/geo-fence-history-selector.component";
import { BusTrackerMapDebugComponent } from "./bus-tracker-map-debug/bus-tracker-map-debug.component";
import { DataService_BusTrackerDebug } from "./bus-tracker-map-debug/shared/data.service";

@NgModule({
	declarations: [
		BusTrackerComponent,
		BusTrackerActivationComponent,
		AddBTActivationComponent,
		EditBTActivationComponent,
		EmailBTActivationComponent,
		BusSelectorComponent,
		BusSelectorBusResultsComponent,
		BusSelectorStudentResultsComponent,
		SchoolBusAlertModifyComponent,
		SchoolBusAlertBusTableComponent,
		SchoolBusAlertTableComponent,
		BusMaintenanceComponent,
		BusMaintenanceBusTableComponent,
		BusMaintenanceRouteTableComponent,
		BusMaintenanceStudentTableComponent,
		BusAlertTypeMaintenanceComponent,
		BusRouteTypeMaintenanceComponent,
		BusAlertTypeModifyComponent,
		BusRouteTypeModifyComponent,
		BusModifyComponent,
		RouteModifyComponent,
		AssignStudentsComponent,
		BusTrackerScanHistoryComponent,
		BusAlertTableComponent,
		BusTrackerGeoFenceMaintenanceComponent,
		GeoFenceSideBarComponent,
		AddGeoFenceComponent,
		EditGeoFenceComponent,
		GeoFenceAlertTableComponent,
		BusTrackerImportComponent,
		BusHistorySelectorComponent,
		BusHistorySelectorBusResultsComponent,
		BusTrackerBusHistoryComponent,
		BusHistorySelectorStudentResultsComponent,
		BusTrackerMainMapComponent,
		BusMainMapComponent,
		BusTrackerSettingsComponent,
		BusOverviewTableComponent,
		BusOverviewStudentTableComponent,
		BusTrackerGeoFenceHistoryComponent,
		GeoFenceHistorySelectorComponent,
		BusTrackerMapDebugComponent,
	],
	imports: [
		BrowserModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		InputTextareaModule,
		CalendarModule,
		AccordionModule,
		SchoolselectorModule,
		ProgressSpinnerModule,
		GMapModule,
		ColorPickerModule,
	],
	providers: [
		ConfirmationService,
		DataService_BusTrackerActivation,
		DataService_BusTrackerMap,
		DataService_BusTrackerAlertType,
		DataService_BusTrackerRouteType,
		DataService_BusTrackerBusMaintenance,
		DataService_BusTrackerGeoFenceMaintenance,
		DataService_BusTrackerScanHistory,
		DataService_BusTrackerBusHistory,
		DataService_BusTrackerSettings,
		DataService_BusTrackerBusOverview,
		DataService_BusTrackerGeoFenceHistory,
		DataService_BusTrackerDebug,
	],
})
export class BusTrackerModule {}
